/**
 * neo-nhan-xet.ts — Neo lại nhận xét vào khối sau khi tài liệu đổi.
 *
 * Nhận xét lưu (line, quote): dòng bắt đầu khối lúc viết + trích đoạn đầu khối.
 * Tài liệu sửa xong thì dòng trôi; trích đoạn mới là thứ nhận ra khối. Thứ tự
 * thử: đúng dòng & đúng trích đoạn → khối nào có trích đoạn đó (gần dòng cũ
 * nhất) → cùng dòng nhưng nội dung đã khác (đánh dấu "đoạn gốc đã đổi").
 */
export interface KhoiNeo { line: number; quote: string }

export interface KetQuaNeo {
  /** Dòng của khối hiện tại; null = không còn khối nào khớp. */
  line: number | null
  /** Khối tìm được nhưng nội dung không còn giống trích đoạn đã lưu. */
  daDoi: boolean
}

const chuan = (s: string) => s.replace(/\s+/g, ' ').trim().toLowerCase()

export function neoLai(nhanXet: KhoiNeo, khoi: KhoiNeo[]): KetQuaNeo {
  const q = chuan(nhanXet.quote)
  const khop = (k: KhoiNeo) => q.length > 0 && chuan(k.quote).startsWith(q)
  const cungDong = khoi.find((k) => k.line === nhanXet.line)
  if (cungDong && (q.length === 0 || khop(cungDong))) return { line: cungDong.line, daDoi: false }
  const ungVien = khoi.filter(khop).sort((a, b) => Math.abs(a.line - nhanXet.line) - Math.abs(b.line - nhanXet.line))
  if (ungVien[0]) return { line: ungVien[0].line, daDoi: false }
  if (cungDong) return { line: cungDong.line, daDoi: true }
  return { line: null, daDoi: true }
}
